<p>
  @if (dynamicFilters$ | async; as dynamicFilters) {
    <span>
      <!-- todo: tooltip -->
      @for (filter of dynamicFilters | keyvalue; track filter) {
        <span class="badge bg-success bg-filter rounded-pill">
          {{ filter.key }}
          <div class="icon-holder">
            <i
              class="fa fa-remove"
              (click)="onRemoveFilter(filter.key)"
              (keydown.enter)="onRemoveFilter(filter.key)"></i>
          </div>
        </span>
      }
    </span>
  }
</p>
